<template>
  <div class="upddate-embed-and-ig">
    <div class="embed-carousel-feed container">
      <div class="embedsocial-hashtag" data-ref="31c59f7c17694584032da30f6b25c0e37ba80662"></div>
    </div>
    <div class="ig-carousel-feed container">
      <div class="embedsocial-hashtag" data-ref="fdf688cec41e5098045c6e9a6eb15a340f68c896"></div>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    (function (d, s, id) {
      var js;
      if (d.getElementById(id)) {
        d.getElementById(id).parentNode.removeChild(d.getElementById(id));
      }
      js = d.createElement(s);
      js.id = id;
      js.src = "https://embedsocial.com/cdn/ht.js";
      d.getElementsByTagName("head")[0].appendChild(js);
    })(document, "script", "EmbedSocialHashtagScript");
  },
};
</script>
